<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Manage billing and payments</h2>
    <div class="margin-top-4">
      <Tabs :tabs="tabs" @setActiveTab="setActiveTab($event)" />
      <transition name="slide-fade">
        <SubscriptionsTable
          v-if="tabs[0].isActive"
          :paymentTab="tabs[1]"
          @subscribed="setActiveTab($event)"
        />
        <PaymentMethods v-if="tabs[1].isActive" />
        <Invoices v-if="tabs[2].isActive" />
      </transition>
    </div>
  </div>
</template>

<script>
import { layouts } from '../helpers'
// import store from '../store'

export default {
  name: 'ManageBillingMain',
  // beforeRouteEnter(routeTo, routeFrom, next) {
  //   if (
  //     store.state.team.team.teamModuleNames.includes(storeModules.swag_store)
  //   ) {
  //     next()
  //   } else if (
  //     store.state.team.team.teamModuleNames.includes(storeModules.project)
  //   ) {
  //     next({ name: 'Projects' })
  //   }
  // },
  data() {
    return {
      tabs: [
        { name: 'Subscription', isActive: true },
        { name: 'Payment', isActive: false },
        { name: 'Invoices', isActive: false }
      ]
    }
  },
  components: {
    Tabs: () => import('../components/Universal/Tabs'),
    SubscriptionsTable: () =>
      import('../components/Billing/SubscriptionsTable'),
    PaymentMethods: () => import('@/components/Billing/PaymentMethods'),
    Invoices: () => import('@/components/Billing/Invoices')
  },
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    if (this.$route.query.tab) {
      let { tab } = this.$route.query
      switch (tab) {
        case 'payment':
          this.tabs[0].isActive = false
          this.tabs[1].isActive = true
          this.tabs[2].isActive = false
          break
        case 'invoice':
          this.tabs[0].isActive = false
          this.tabs[1].isActive = false
          this.tabs[2].isActive = true
          break
        default:
          this.tabs[0].isActive = true
          this.tabs[1].isActive = false
          this.tabs[2].isActive = false
          break
      }
    }
  },
  methods: {
    setActiveTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name === selectedTab.name
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';
</style>
